<template>
  <div>
    <div class="secondary-nav">
      <div class="font-weight-bold">{{ 'Prompt Editor' | trans }}</div>
      <div class="">
        <router-link
            v-slot="{ href, route, navigate, isActive, isExactActive }"
            :to="{ name: 'JobCanvas', params: { uuid: id } }"
        >
          <button @click="navigate" class="btn-back btn text-white font-weight-bold">
            <i class="fa lh-inherit fa-chevron-left"></i> {{ 'Back' | trans }}
          </button>
        </router-link>
      </div>
    </div>
    <div class="p-20 justify-content-center d-flex">
      <div class="content-container">
        <div class="d-flex align-items-center">
          <svg width="21" height="14" viewBox="0 0 12 8" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M1.33325 0.666626L4.66659 3.99996L1.33325 7.33329M6.66659 7.33329H10.6666"
                stroke="white"
                stroke-width="1.33333"
                stroke-linecap="round"
                stroke-linejoin="round"
            />
          </svg>
          <h1 class="text-white ml-1">{{ 'Prompt Editor' | trans }}</h1>
        </div>
        <div>
          <prompt :isRowDynamic="true"></prompt>
        </div>
        <div>
          <p>
            {{
              'Click on different prompt items to curate a unique and tailored prompt that perfectly aligns with your artistic vision and improves your overall result.' | trans
            }}
          </p>
        </div>
        <div>
          <prompt-editor></prompt-editor>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import store from './../../mixins/store.mixin';
import currentJob from './../../mixins/current_job.mixin';
import Prompt from '../Settings/Prompt.vue';
import PromptEditor from '../Settings/PromptEditor.vue';
import Analytics from "../../util/Analytics";

export default {
  name: 'PromptEditorCanvas',
  components: {
    Prompt,
    PromptEditor,
  },
  mounted: function () {
    Analytics.send('creator_studio_action', `open_prompt_editor`, this.currentJob);
  },
  mixins: [store, currentJob],
};
</script>
<style scoped>
.content-container {
  color: white;
  display: flex;
  flex-direction: column;
  gap: 20px;
}
</style>
